import React, { useEffect, useState } from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import { ThemeContext } from "./ThemeContext";
import { NsTheme, NsThemeName } from "../ns-eds-types";
import { light } from "../ns-theme-light";
import { dark } from "../ns-theme-dark";
import { setTractieColorScheme } from "../setTractieColorScheme";

interface ThemeProviderProps extends React.PropsWithChildren {
  readonly theme?: NsTheme;
}

export function ThemeProvider({
  theme: initialTheme = light,
  children,
}: ThemeProviderProps): React.JSX.Element {
  const [theme, setTheme] = useState<NsTheme>(initialTheme);

  useEffect(() => {
    setTractieColorScheme(theme.name);
  }, [theme.name]);

  const setThemeByName = (name: NsThemeName) => {
    setTheme(name === "light" ? light : dark);
  };

  const isLightTheme = theme.name === "light";

  return (
    <ThemeContext value={{ theme, isLightTheme, setTheme, setThemeByName }}>
      <SCThemeProvider theme={theme}>{children}</SCThemeProvider>
    </ThemeContext>
  );
}
